// extracted by mini-css-extract-plugin
export var icon = "_7z-1";
export var subtext = "_7z-0";